'use strict';

import uiRouter from '@uirouter/angularjs';

import schemaForm from 'angular-schema-form';
import 'angular-schema-form-bootstrap';

import PatientsService from './services/patientsservice';

export default angular
  .module('emilPatients', [
    uiRouter,
    schemaForm.name,
  ])
  .config(['$stateProvider', 'schemaFormDecoratorsProvider', 'schemaFormProvider', 'sfPathProvider', 'sfBuilderProvider',
           function ($stateProvider, schemaFormDecoratorsProvider, schemaFormProvider, sfPathProvider, sfBuilderProvider) {
    $stateProvider
    
    .state('main.patients', {
      abstract: true,
      url: 'patienten',
      template: '<ui-view/>',
      data: {
        proxy: 'main.patients.list'
      }
    })
    .state('main.patients.list', {
      url: '/uebersicht',
      component: 'patientList',
      params: {
        permission: '11111'
      },
      data: {
        displayName: 'Patientenübersicht'
      }
    })
    .state('main.patients.add', {
      url: '/neu',
      component: 'formPatient',
      params: {
        permission: '00110'
      },
      data: {
        displayName: 'Patient anlegen'
      }
    })
    .state('main.patients.edit', {
      url: '/bearbeiten/:pid',
      component: 'formPatient',
      params: {
        patient: undefined,
        permission: '00111'
      },
      data: {
        displayName: 'Patient bearbeiten'
      }
    })
    .state('main.patients.list.details', {
      url: '/:pid',
      component: 'patientDetails',
      params: {
        patient: undefined,
        permission: '11110'
      },
      resolve: {
        patient: ['PatientsService', '$stateParams', function(PatientsService, $stateParams) {
          return $stateParams.patient || PatientsService.findByPid($stateParams.pid);
        }]
      },
      data: {
        displayName: 'Details Patient'
      }
    })
    .state('main.patients.list.details.treatsteps', {
      component: 'treatmentSteps',
      resolve: {
        'patient': ['$stateParams', function($stateParams){
          return $stateParams.patient;
        }],
        'treatment': ['$stateParams', function ($stateParams) {
          return $stateParams.treatment;
        }]
      },
      bindings: {
        patient: 'patient',
        treatment: 'treatment'
      },
      params: {
        treatment: undefined,
        treatId: undefined,
        permission: '11110'
      },
      data: {
        displayName: ''
      }
    })
    .state('main.patients.list.details.treatform', {
      component: 'formTreatmentStep',
      resolve: {
        'patient': ['$stateParams', function($stateParams){
          return $stateParams.patient;
        }],
        'treatment': ['$stateParams', function ($stateParams) {
          return $stateParams.treatment;
        }]
      },
      bindings: {
        patient: 'patient',
        treatment: 'treatment'
      },
      params: {
        treatment: undefined,
        permission: '10110'
      },
      data: {
        displayName: ''
      }
    })
    .state('main.patients.formview', {
      url: '/:pid/behandlung/:treatId/:actionId',
      component: 'formTreatment',
      params: {
        permission: '11110'
      },
      data: {
        displayName: 'Behandlung'
      }
    })
    .state('main.patients.formview.changes', {
      component: 'treatmentStepsChangelog',
      resolve: {
        'change': ['$stateParams', function ($stateParams) {
          return $stateParams.change;
        }]
      },
      bindings: {
        change: 'change'
      },
      params: {
        change: undefined,
        permission: '10110'
      }
    });

    var calculator = function(name, schema, options) {
      if (schema['x-calc']) {
        var f = schemaFormProvider.stdFormObj(name, schema, options);
        f.key = options.path;
        f.type = 'calculator';
        options.lookup[sfPathProvider.stringify(options.path)] = f;
        return f;
      }
    };

    var datepicker = function(name, schema, options) {
      // add custom datepicker to schema-form
      if (schema.type === 'string' && schema.format === 'date') {
        if (schema['x-today']) {
          schema['default'] = new Date();
        }

        var f = schemaFormProvider.stdFormObj(name, schema, options);
        f.key = options.path;
        f.type = 'datepicker';
        options.lookup[sfPathProvider.stringify(options.path)] = f;
        return f;
      }
    };

    var opsWizard = function(name, schema, options) {
      // add custom datepicker to schema-form
      if (schema.type === 'string' && schema.format === 'ops') {

        var f = schemaFormProvider.stdFormObj(name, schema, options);
        f.key = options.path;
        f.type = 'ops';
        options.lookup[sfPathProvider.stringify(options.path)] = f;
        return f;
      }
    };


    schemaFormProvider.defaults.string.unshift(datepicker);
    schemaFormProvider.defaults.string.unshift(opsWizard);
    schemaFormProvider.defaults.string.unshift(calculator);
    schemaFormProvider.defaults.number.unshift(calculator);

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'datepicker',
      require('!file-loader!./components/schema-form-datepicker/datepicker.html')
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'ops',
      require('!file-loader!./components/schema-form-opswizard/opswizard.html')
    );


    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'calculator',
      require('!file-loader!./components/schema-form-calculator/calculator.html')
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'select-center',
      require('!file-loader!./components/schema-form-select/center.html')
    );
  
    schemaFormDecoratorsProvider.defineAddOn(
      'bootstrapDecorator',
      'fieldset',
      'fieldset.html',
      [sfBuilderProvider.builders.transclusion, sfBuilderProvider.builders.sfField, sfBuilderProvider.builders.condition]
    );

    schemaFormDecoratorsProvider.defineAddOn(
      'bootstrapDecorator',
      'radios-inline',
      'radios-inline.html',
      [sfBuilderProvider.builders.sfField, sfBuilderProvider.builders.condition, sfBuilderProvider.builders.ngModel, sfBuilderProvider.builders.ngModelOptions]
    );
  }])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put('fieldset.html', require('!html-loader!./components/reccordDecorator/fieldset.html'));
    $templateCache.put('radios-inline.html', require('!html-loader!./components/reccordDecorator/radios-inline.html'));
  }])
  .component('formPatient', require('./components/form-patient/form-patient.component'))
  .component('formTreatment', require('./components/form-treatment/form-treatment.component'))
  .component('formTreatmentStep', require('./components/form-treatment-step/form-treatment-step.component'))
  .component('masterData', require('./components/tile-patient-masterdata/patient-masterdata.component'))
  .component('medications', require('./components/medications/medications.component'))
  .component('opsWizard', require('./components/ops-wizard/ops-wizard.component'))
  .component('overdueTreatments', require('./components/list-overdue-treatments/overdue-treatments.component'))
  .component('patientDetails', require('./components/patient-details/patients-details.component'))
  .component('patientList', require('./components/list-patients/patients.component'))
  .component('recentPatients', require('./components/list-recent-patients/recent-patients.component'))
  .component('targetLesionsTile', require('./components/tile-target-lesions/target-lesions.component'))
  .component('targetLesions', require('./components/target-lesions/target-lesions.component'))
  .component('treatments', require('./components/tile-treatments/treatments.component'))
  .component('treatmentSteps', require('./components/tile-treatment-steps/treatment-steps.component'))
  .component('treatmentStepsChangelog', require('./components/treatment-steps-changelog/treatment-steps-changelog.component'))
  .component('treatmentStepsHistory', require('./components/treatment-steps-history/treatment-steps-history.component'))

  .directive('calculate', require('./components/schema-form-calculator/schema-form-calculator'))
  .service('PatientsService', PatientsService)
;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/patients.module.js